(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oos-similar-swapper"] && !Shopify.designMode) return;
  try {
    (function () {
    var FLAVOR_MAP = {
      pouches: {
        wintergreen: ['mint'],
        mint: ['mint'],
        cinnamon: ['apple cider'],
        mango: ['mango'],
        'apple ice': ['apple ice'],
        apple: ['apple ice'],
        espresso: ['espresso'],
      },
      breakers: {
        mint: ['mint', 'wintergreen'],
        'apple cider': ['cinnamon'],
        mango: ['mango'],
        'apple ice': ['apple ice'],
        espresso: ['espresso'],
      },
    };

    var PACK_CATALOG = {
      breakers: [
        { variant_id: 45737934127290, sku: 'LB5X4MGMTUS', title: '4mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934160058, sku: 'LB5X4MGAIUS', title: '4mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934192826, sku: 'LB5X4MGMGUS', title: '4mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934225594, sku: 'LB5X4MGBCUS', title: '4mg / Berry Citrus / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934258362, sku: 'LB5X4MGESUS', title: '4mg / Espresso / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934291130, sku: 'LB5X4MGACUS', title: '4mg / Apple Cider / 5-Pack', size: '5-Pack' },
        { variant_id: 43365669241018, sku: 'LB6X4MGVAUS', title: '4mg / Variety (All Flavors) / 6-Pack', size: '6-Pack' },
        { variant_id: 45737934323898, sku: 'LB5X8MGMTUS', title: '8mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934356666, sku: 'LB5X8MGAIUS', title: '8mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934389434, sku: 'LB5X8MGMGUS', title: '8mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934422202, sku: 'LB5X8MGBCUS', title: '8mg / Berry Citrus / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934454970, sku: 'LB5X8MGESUS', title: '8mg / Espresso / 5-Pack', size: '5-Pack' },
        { variant_id: 45737934487738, sku: 'LB5X8MGACUS', title: '8mg / Apple Cider / 5-Pack', size: '5-Pack' },
        { variant_id: 43365669208250, sku: 'LB6X8MGVAUS', title: '8mg / Variety (All Flavors) / 6-Pack', size: '6-Pack' },
        { variant_id: 46041865650362, sku: 'LB5X12MGMTUS', title: '12mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 46041865683130, sku: 'LB5X12MGAIUS', title: '12mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 46041865715898, sku: 'LB5X12MGMGUS', title: '12mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 46041865748666, sku: 'LB5X12MGBCUS', title: '12mg / Berry Citrus / 5-Pack', size: '5-Pack' },
        { variant_id: 46041865814202, sku: 'LB5X12MGACUS', title: '12mg / Apple Cider / 5-Pack', size: '5-Pack' },
      ],
      pouches: [
        { variant_id: 45737841459386, sku: 'LP5X4MGWTUS', title: '4mg / Wintergreen / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841492154, sku: 'LP5X4MGMGUSX', title: '4mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841524922, sku: 'LP5X4MGCNUS', title: '4mg / Cinnamon / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841557690, sku: 'LP5X4MGAIUSX', title: '4mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841590458, sku: 'LP5X4MGESUSX', title: '4mg / Espresso / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841623226, sku: 'LP5X4MGMTUS', title: '4mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 41980094578874, sku: 'LP6X4MGV2US', title: '4mg / Variety (All Flavors) / 6-Pack', size: '6-Pack' },
        { variant_id: 45737841262778, sku: 'LP5X8MGWTUS', title: '8mg / Wintergreen / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841295546, sku: 'LP5X8MGMGUSX', title: '8mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841328314, sku: 'LP5X8MGCNUS', title: '8mg / Cinnamon / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841361082, sku: 'LP5X8MGAIUSX', title: '8mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841393850, sku: 'LP5X8MGESUS', title: '8mg / Espresso / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841426618, sku: 'LP5X8MGMTUS', title: '8mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 41980094742714, sku: 'LP6X8MGV2US', title: '8mg / Variety (All Flavors) / 6-Pack', size: '6-Pack' },
        { variant_id: 45737841655994, sku: 'LP5X12MGWTUS', title: '12mg / Wintergreen / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841688762, sku: 'LP5X12MGMGUSX', title: '12mg / Mango / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841721530, sku: 'LP5X12MGCNUS', title: '12mg / Cinnamon / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841754298, sku: 'LP5X12MGAIUS', title: '12mg / Apple Ice / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841787066, sku: 'LP5X12MGESUS', title: '12mg / Espresso / 5-Pack', size: '5-Pack' },
        { variant_id: 45737841819834, sku: 'LP5X12MGMTUS', title: '12mg / Mint / 5-Pack', size: '5-Pack' },
        { variant_id: 41954843492538, sku: 'LP6X12MGV2US', title: '12mg / Variety (All Flavors) / 6-Pack', size: '6-Pack' },
      ],
    };

    var PACKS = {
      breakers: PACK_CATALOG.breakers.map(enrichPack),
      pouches: PACK_CATALOG.pouches.map(enrichPack),
    };

    function initOosSimilarSwapper() {
      var swapper = document.querySelector('[data-oos-similar-swapper]');
      var liveEl = document.querySelector('[data-oos-swapper-live]');
      if (!swapper || !liveEl) return;

      var liveById = {};
      try {
        var liveList = JSON.parse(liveEl.textContent);
        if (Array.isArray(liveList)) {
          liveList.forEach(function (entry) {
            if (entry && entry.id != null) liveById[String(entry.id)] = entry;
          });
        } else {
          liveById = liveList || {};
        }
      } catch (e) {
        liveById = {};
      }

      var currentLine = swapper.getAttribute('data-current-line');
      var targetHandle = swapper.getAttribute('data-target-handle');
      var targetLine = currentLine === 'pouches' ? 'breakers' : 'pouches';
      var link = swapper.querySelector('.oos-similar-swapper__link');
      var flavorEl = swapper.querySelector('[data-oos-swapper-flavor]');

      function getSelectedVariantId() {
        var root = document.querySelector('variant-radios, variant-selects');
        if (root && root.currentVariant) return root.currentVariant.id;

        var urlId = new URLSearchParams(window.location.search).get('variant');
        if (urlId) return urlId;

        var input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        return input && input.value;
      }

      function getSelectedShopifyVariant() {
        var root = document.querySelector('variant-radios, variant-selects');
        if (root && root.currentVariant) return root.currentVariant;

        var script = root && root.querySelector('script[type="application/json"]');
        if (!script) return null;

        try {
          var variants = JSON.parse(script.textContent);
          var selectedId = getSelectedVariantId();
          return (
            variants.find(function (variant) {
              return String(variant.id) === String(selectedId);
            }) || null
          );
        } catch (err) {
          return null;
        }
      }

      function isArtificialOos(variantId) {
        var map = window.disableSellingOptionsByVariantID;
        if (!map || variantId == null) return false;
        return Object.values(map).map(String).includes(String(variantId));
      }

      function isCurrentOos(variant) {
        if (!variant) return false;
        return variant.available === false || isArtificialOos(variant.id);
      }

      function isSellable(pack) {
        if (!pack) return false;
        if (isArtificialOos(pack.variant_id)) return false;
        var live = liveById[String(pack.variant_id)];
        if (live && live.available === false) return false;
        return true;
      }

      function packUrl(pack) {
        var live = liveById[String(pack.variant_id)];
        if (live && live.url) return live.url;
        return '/products/' + targetHandle + '?variant=' + pack.variant_id;
      }

      function findMatch(variantId) {
        var current = findPack(currentLine, variantId);
        if (!current) return null;

        if (current.size === '6-Pack') {
          if (current.strength === '12mg') return null;
          var sixPack = PACKS[targetLine].find(function (pack) {
            return pack.size === '6-Pack' && pack.strength === current.strength && isSellable(pack);
          });
          return sixPack || null;
        }

        if (current.flavor === 'espresso' && current.strength === '12mg') return null;

        var flavorTargets = (FLAVOR_MAP[currentLine] || {})[current.flavor];
        if (!flavorTargets) return null;

        for (var i = 0; i < flavorTargets.length; i++) {
          var wantedFlavor = flavorTargets[i];
          var match = PACKS[targetLine].find(function (pack) {
            return (
              pack.size === '5-Pack' &&
              pack.strength === current.strength &&
              pack.flavor === wantedFlavor &&
              isSellable(pack)
            );
          });
          if (match) return match;
        }

        return null;
      }

      function updateSwapper() {
        var currentVariant = getSelectedShopifyVariant();
        var variantId = (currentVariant && currentVariant.id) || getSelectedVariantId();
        var match = isCurrentOos(currentVariant) || isArtificialOos(variantId) ? findMatch(variantId) : null;

        if (!match) {
          swapper.hidden = true;
          return;
        }

        if (link) link.href = packUrl(match);
        if (flavorEl) flavorEl.textContent = match.flavor === 'variety' ? 'Variety' : titleCase(match.flavor);
        swapper.hidden = false;
      }

      var root = document.querySelector('variant-radios, variant-selects');
      if (root) root.addEventListener('change', updateSwapper);

      updateSwapper();
    }

    function enrichPack(entry) {
      var parts = String(entry.title || '').split(' / ');
      var strengthMatch = (parts[0] || '').match(/(\d+)\s*mg/i);
      var flavorLabel = parts[1] || '';
      var flavor = /variety/i.test(flavorLabel) ? 'variety' : normalizeFlavor(flavorLabel);

      return {
        variant_id: entry.variant_id,
        sku: entry.sku,
        title: entry.title,
        size: entry.size,
        strength: strengthMatch ? strengthMatch[1] + 'mg' : '',
        flavor: flavor,
      };
    }

    function findPack(line, variantId) {
      return (
        (PACKS[line] || []).find(function (pack) {
          return String(pack.variant_id) === String(variantId);
        }) || null
      );
    }

    function normalizeFlavor(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[()]/g, '')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function titleCase(value) {
      return String(value || '')
        .split(' ')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOosSimilarSwapper);
    } else {
      initOosSimilarSwapper();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
